import { postData } from './api'
import { getSettings, updateSettings } from './settings'
import { isClient } from './utils'
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
const locationHelper = locationHelperBuilder({})

export function login(cred) {
   return new Promise((resolve, reject) => {
        postData('wpapi/login', cred)
            .then(response => {
                if (response.token) {
                    var dateNow = new Date();

                    localStorage.setItem('jwtToken', response.token)
                    localStorage.setItem('jwtExpiry', response.token_expires)
                    localStorage.setItem('userId', response.user_id)

                    resolve(response.token);
                }
            })
            .catch(error =>  {
                reject(error)
            })   
    })      
}

export function forgotPassword(formData) {
    return new Promise((resolve, reject) => {
        postData('wpapi/forgot-password', formData)
            .then(response => {
                console.log(response)
                resolve(response)
            })
            .catch(error =>  {
                console.log(error)
                reject(error)
            })   
     })      
 }

export const userIsAuthenticated = connectedRouterRedirect({
    redirectPath: '/login',
    authenticatedSelector: state => {
        return state.settings.settings.isAuthenticated
    },
    wrapperDisplayName: 'UserIsAuthenticated'
})


 export const userIsNotAuthenticated = connectedRouterRedirect({
    redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/',
    allowRedirectBack: false,
    authenticatedSelector: state => state.settings.settings.isAuthenticated,
    wrapperDisplayName: 'UserIsNotAuthenticated'
})
 
export function isAuthenticated() {

    if (!isClient()) return false // return true on server

    let jwtToken = localStorage.getItem('jwtToken');
    let jwtExpiry = localStorage.getItem('jwtExpiry');
    var dateNow = Math.round(+ new Date()/1000);

    if (jwtToken && jwtExpiry && (parseInt(jwtExpiry) > dateNow)) {
        return true
    } else {
        return false
    }
}



// WEBPACK FOOTER //
// ./client/auth.js